export default __webpack_public_path__ + "static/yeti-fur-pink-6849ecd5bf978abe24929ff70dd96465.jpg";